export default __webpack_public_path__ + "static/media/hide.d24911ba.svg";